import { jsx } from 'panel';
export function template() {
  const {
    visibility
  } = this.state;
  const direction = this.attr("direction");
  return jsx("div", {
    sel: '.mp-drop-menu-body',
    attrs: {
      elref: "contentBody"
    },
    class: {
      ["is-direction-".concat(direction)]: true,
      ["is-".concat(visibility)]: true
    },
    hook: this.helpers.isResponsive() ? {
      postpatch: this.helpers.onBodyPatch
    } : {}
  }, this.attr("with-caret") ? jsx("div", {
    sel: '.mp-drop-menu-caret',
    style: {
      left: this.caretPos.left,
      right: this.caretPos.right
    },
    class: {
      'is-inverted': direction === "up"
    }
  }) : null, jsx("slot", null));
}